import { Flag } from 'lucide-react';
import * as React from 'react';
import { Link } from 'react-router-dom';
import './community-reports-banner.scss';

interface CommunityReportsBlock {
  reasons: string[];
  reporterCount: number;
  state: 'UNDER_REVIEW' | 'CONFIRMED';
}

interface Props {
  communityReports: CommunityReportsBlock | null;
  isOwnPost: boolean;
  postId?: string;
}

export const CommunityReportsBanner: React.FC<Props> = ({
  communityReports,
  isOwnPost,
  postId,
}) => {
  if (!communityReports) return null;

  const { reasons, reporterCount, state } = communityReports;
  const stateLabel = state === 'CONFIRMED' ? 'Confirmed' : 'Under review';
  const readerWord = reporterCount === 1 ? 'reader' : 'readers';

  return (
    <div
      className="community-reports-banner"
      role="status"
      data-testid="community-reports-banner"
    >
      <Flag size={16} aria-hidden="true" />
      <span className="community-reports-banner__copy">
        <strong>
          Flagged by {reporterCount} {readerWord}
        </strong>{' '}
        for {reasons.join(', ')} · <em>{stateLabel}</em>
      </span>
      {isOwnPost && postId && (
        <Link
          to={`/post/${postId}/edit-rewrite`}
          className="community-reports-banner__action"
        >
          Review and revise
        </Link>
      )}
    </div>
  );
};
